// extracted by mini-css-extract-plugin
module.exports = {"switch":"styles_switch__1x3J4","active":"styles_active__2PRow","switch__circle":"styles_switch__circle__ZjFNz"};